module.exports = __webpack_public_path__ + "static/media/display-3@768.ce5ce4b8.png";